import clsx from 'clsx';
import type { DpPeriodCell } from '../../../utils/vacationDpPeriods';
import { CELL_TONE_CLASSES, NOT_APPLICABLE } from '../vacationDpTable.definitions';
import type { CellTone } from '../vacationDpTable.types';

export interface VacationDpPeriodCellProps {
    cell: DpPeriodCell | null;
}

export function VacationDpPeriodCell({ cell }: VacationDpPeriodCellProps) {
    if (!cell) {
        return <span className="font-montserrat text-raro-gray-400">{NOT_APPLICABLE}</span>;
    }

    return (
        <div className="space-y-0.5">
            <span className="font-montserrat text-raro-gray-900">{cell.label}</span>
            {cell.hint && (
                <div className="text-xs text-raro-gray-500 font-montserrat">{cell.hint}</div>
            )}
        </div>
    );
}
